import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const CalendarDropoff = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default CalendarDropoff;
